
import { defineComponent, onMounted } from 'vue'
import { useMeta } from 'vue-meta'
import { RoofHeaderText } from '@squareroof-admin/ui-components'
import { Logic } from '@unwind-admin/logic'
import { scrollToTop } from '@/composables'

export default defineComponent({
  components: {
    RoofHeaderText,
  },
  name: 'UserEngagments',
  layout: 'Dashboard',
  middlewares: {},
  setup() {
    useMeta({
      title: 'Users Engagements',
    })

    onMounted(() => {
      scrollToTop()
    })

    return {
      Logic,
    }
  },
})
